import { render, staticRenderFns } from "./DownloadArea.vue?vue&type=template&id=593d8232&"
import script from "./DownloadArea.vue?vue&type=script&lang=ts&"
export * from "./DownloadArea.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadArea.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports